import { useEffect, useState } from "react";
import { Calendar, MapPin, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api, SUBCATEGORY_LABELS } from "../../lib/api";

const MONTHS = ["jan","fév","mar","avr","mai","juin","juil","aoû","sep","oct","nov","déc"];

export default function EventsSection() {
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get("/places/events/upcoming", { params: { limit: 6 } }).then(r => setEvents(r.data)).catch(()=>{}); }, []);
  if (events.length === 0) return null;

  return (
    <section className="px-4 sm:px-6 max-w-7xl mx-auto" data-testid="events-section">
      <div className="flex items-end justify-between mb-5">
        <div>
          <div className="uppercase-label text-[#00A6B3] flex items-center gap-1.5"><Sparkles size={12}/> À ne pas manquer</div>
          <h2 className="font-display font-black text-2xl sm:text-3xl tracking-tighter text-[#1A1A1A] mt-1">
            Ce week-end & bientôt
          </h2>
        </div>
      </div>
      <div className="flex gap-4 overflow-x-auto no-scrollbar -mx-4 sm:-mx-6 px-4 sm:px-6 pb-2 snap-x snap-mandatory">
        {events.map((e, i) => {
          const d = e.event_date ? new Date(e.event_date) : null;
          return (
            <motion.div
              key={e.id}
              data-testid={`event-card-${e.id}`}
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.35, delay: i * 0.05 }}
              className="snap-start shrink-0 w-[300px] rounded-3xl overflow-hidden bg-white shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all border border-black/5"
            >
              <div className="relative h-40 overflow-hidden">
                {e.image_url && <img src={e.image_url} alt={e.name} className="w-full h-full object-cover"/>}
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"/>
                {d && (
                  <div className="absolute top-3 left-3 bg-white rounded-2xl px-3 py-1.5 text-center shadow-lg">
                    <div className="font-display font-black text-xl leading-none text-[#FF6B35]">{d.getDate()}</div>
                    <div className="uppercase-label text-[#1A1A1A]/70 text-[9px] mt-0.5">{MONTHS[d.getMonth()]}</div>
                  </div>
                )}
                {e.subcategory && (
                  <div className="absolute top-3 right-3 bg-[#00A6B3] text-white text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full">
                    {SUBCATEGORY_LABELS[e.subcategory] || e.subcategory}
                  </div>
                )}
              </div>
              <div className="p-4">
                <h3 className="font-display font-bold text-lg text-[#1A1A1A] leading-tight">{e.name}</h3>
                <div className="flex items-center gap-1 text-xs text-[#1A1A1A]/60 mt-1.5">
                  <MapPin size={12}/>{e.city}
                  {d && <><span>·</span><Calendar size={12}/>{d.toLocaleDateString("fr-FR", { weekday: "short", day:"numeric", month: "short" })}</>}
                </div>
                <Link to={`/place/${e.id}`} data-testid={`event-detail-${e.id}`}
                  className="mt-3 inline-block text-sm font-bold text-[#00A6B3] hover:underline">Y participer →</Link>
              </div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
